// extracted by mini-css-extract-plugin
module.exports = {"acidAnswer":"AcidAnswer_acidAnswer__1EGa2","acidList":"AcidAnswer_acidList__1d7BF","acidItem":"AcidAnswer_acidItem__3M6-D"};